import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const MarvinEmpty = styled.div<{height?: boolean}>`
display:flex;
  justify-content: center;
  align-items: center;
    width:70%;
    height:90%;
    margin: 0 auto;
    position: relative;
`;

export const EmptyBoxContent = styled.div`
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap:2rem;
    width:70%;
    height:90%;
    margin: 0 auto;

    > div {
        background: #ececec;
        display:flex;
        justify-content: center;
        align-items: center;
        width:140px;
        height:140px;
        border-radius: 50%;
    }

    svg{
        height:100%;
        max-width:70%;
        max-height:70%;
        path{
            fill:#949393;
        }
    }

    p{
        font-size: 18px;
        color:#949393;
        text-align: center;
    }
`;